import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // 💡 Assure-toi que les styles scrollbar sont bien là-dedans
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext'; // ✅ Fournisseur de contexte utilisateur

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <App />
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
